module.exports = __webpack_public_path__ + "@/assets/img/bannerReferido.04a8b0aa.gif";